import { memo } from 'react';

import { cn } from '../../../lib/cn';

interface TagsCellProps {
  values: string[] | null | undefined;
  maxVisible?: number;
  className?: string;
}

export const TagsCell = memo(function TagsCell({
  values,
  maxVisible = 3,
  className,
}: TagsCellProps) {
  if (!values || values.length === 0) {
    return <span className="text-slate-400">-</span>;
  }

  const visible = values.slice(0, maxVisible);
  const remaining = values.length - maxVisible;

  return (
    <div className={cn('flex flex-wrap gap-1', className)}>
      {visible.map((tag) => (
        <span
          key={tag}
          className="inline-flex items-center rounded-full bg-slate-100 px-2 py-0.5 text-xs font-medium text-slate-700"
        >
          {tag}
        </span>
      ))}
      {remaining > 0 && (
        <span className="inline-flex items-center rounded-full bg-slate-100 px-2 py-0.5 text-xs font-medium text-slate-500">
          +{remaining}
        </span>
      )}
    </div>
  );
});
